module.exports = __webpack_public_path__ + "img/gmtc.7535f0c5.png";